import { BASE_IMG_URL } from "constants/configConstants";
import styles from "./HeroV2.module.scss";
import { useRef, useState } from "react";
import useToggleShowNavbar from "hooks/useToggleShowNavbar";
import HeaderDesktop from "@Components/Header/HeaderDesktop";
import HeroContent from "./components/HeroContent/HeroContent";
import HeroImageContainer from "./components/HeroImageHolder/HeroImageHolder";
import wrapperHOC from "@Utils/wrapperHOC";
import { useSelector } from "react-redux";
import { AppState } from "@Store/index";

const HeroV2 = ({ isReferralPage = false }: { isReferralPage?: boolean }) => {
  const heroSectionRef: any = useRef();
  const searchBarRef: any = useRef();
  const [isSearchScrolledUp, setIsSearchScrolledUp] = useState(false);
  const [showSearchButtonOnScrollBar, setShowSearchButtonOnScrollBar] = useState(false);
  useToggleShowNavbar(heroSectionRef, setIsSearchScrolledUp);
  useToggleShowNavbar(searchBarRef, setShowSearchButtonOnScrollBar);

  const { isUserLoggedIn } = useSelector(({ appData }: AppState) => ({
    isUserLoggedIn: appData.isUserLoggedIn,
  }));

  return (
    <>
      <div className={`${styles.stickyHeader}${isSearchScrolledUp ? ` ${styles.visible}` : ""}`}>
        {showSearchButtonOnScrollBar ? (
          <HeaderDesktop
            hideAppBanner
            isReferralPage={isReferralPage}
            showSearchButtonOnScrollBar
          />
        ) : (
          <HeaderDesktop hideAppBanner hideSearchBar isReferralPage={isReferralPage} />
        )}
      </div>
      <HeaderDesktop
        hideSearchBar
        transparentBg
        isFixed
        hideAppBanner
        showCookiePolicy
        isReferralPage={isReferralPage}
      />
      <div
        className={
          isUserLoggedIn ? styles.refParentContainerAuthenticated : styles.refParentContainer
        }
        style={{ backgroundImage: `url(${BASE_IMG_URL}referralv2-bg.png)` }}
      >
        <div className={styles.refOverlayContainer}>
          <div
            className={
              isUserLoggedIn ? styles.refContentContainerAuthenticated : styles.refContentContainer
            }
            ref={heroSectionRef}
          >
            <HeroContent />
            <HeroImageContainer />
          </div>
          <div className={styles.refHookContainer} ref={searchBarRef} />
        </div>
      </div>
    </>
  );
};

export default wrapperHOC(HeroV2, {
  componentName: "HeroV2-ReferralDesktop",
  showForChina: true,
});
